import { Icon } from "@iconify/react";
// icons
import mapPinIcon from "@iconify/icons-feather/map-pin";
import packageIcon from "@iconify/icons-feather/package";
import shoppingBagIcon from "@iconify/icons-feather/shopping-bag";
import dollarSignIcon from "@iconify/icons-feather/dollar-sign";
import gridIcon from "@iconify/icons-feather/grid";
import customerIcon from "@iconify/icons-feather/trending-up";
import calendarIcon from "@iconify/icons-feather/calendar";
import sunIcon from "@iconify/icons-feather/sun";
import usersIcon from "@iconify/icons-feather/users";
import fileTextIcon from "@iconify/icons-feather/file-text";
import starIcon from "@iconify/icons-feather/star";
import messageCircleIcon from "@iconify/icons-feather/message-circle";
import { ROUTES } from "@admin/routes/paths";
import { LIVE_CHAT_URL } from "@admin/utils/constants";

const renderIcon = (icon) => (
  <Icon icon={icon} style={{ width: "100%", height: "100%" }} />
);

const sidebarConfig = [
  // GENERAL
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: ROUTES.general.welcome,
        icon: renderIcon(gridIcon),
      },
      {
        title: "Orders",
        path: ROUTES.order.root,
        icon: renderIcon(shoppingBagIcon),
        children: [{ title: "List", path: ROUTES.order.list }],
      },
      {
        title: "Discounts",
        path: ROUTES.price.root,
        icon: renderIcon(dollarSignIcon),
        children: [
          {
            title: "Coupons",
            path: ROUTES.price.coupon.list,
          },
          {
            title: "Discounts",
            path: ROUTES.price.discount.list,
          },
        ],
      },
      {
        title: "Special Offers",
        path: ROUTES.special_offer.list,
        icon: renderIcon(starIcon),
      },
      {
        title: "Customers",
        path: ROUTES.customer.root,
        icon: renderIcon(customerIcon),
        children: [
          { title: "All", path: ROUTES.customer.all },
          { title: "With purchases ", path: ROUTES.customer.withPurchases },
        ],
      },
    ],
  },

  // CATALOG
  {
    subheader: "catalog",
    items: [
      {
        title: "Products",
        path: ROUTES.product.root,
        icon: renderIcon(packageIcon),
        children: [
          { title: "List", path: ROUTES.product.list },
          { title: "Create", path: ROUTES.product.new },
        ],
      },
      {
        title: "Categories",
        path: ROUTES.category.root,
        icon: renderIcon(calendarIcon),
        children: [
          { title: "List", path: ROUTES.category.list },
          { title: "Create", path: ROUTES.category.new },
        ],
      },
      {
        title: "Colors",
        path: ROUTES.color.root,
        icon: renderIcon(sunIcon),
        children: [
          { title: "List", path: ROUTES.color.list },
          { title: "Create", path: ROUTES.color.new },
        ],
      },
    ],
  },

  // MANAGEMENT
  {
    subheader: "management",
    items: [
      {
        title: "Users",
        path: ROUTES.user.root,
        icon: renderIcon(usersIcon),
        children: [
          { title: "List", path: ROUTES.user.list },
          { title: "Create", path: ROUTES.user.new },
        ],
      },
      {
        title: "Locations",
        path: ROUTES.location.root,
        icon: renderIcon(mapPinIcon),
        children: [
          { title: "List", path: ROUTES.location.list },
          { title: "Create", path: ROUTES.location.new },
        ],
      },
      {
        title: "Pages",
        path: ROUTES.page.root,
        icon: renderIcon(fileTextIcon),
        children: [
          { title: "List", path: ROUTES.page.list },
          { title: "Create", path: ROUTES.page.new },
        ],
      },
      {
        title: "Live Chat",
        path: LIVE_CHAT_URL,
        icon: renderIcon(messageCircleIcon),
        external: true,
      },
    ],
  },
];

export default sidebarConfig;
